import type { StoreApi } from 'zustand';
import type { SessionUiState } from '../sessionUiState';

export function createSessionUiSlice(set: StoreApi<SessionUiState>['setState']): SessionUiState {
  return {
    activeTab: 'steps',
    selectedId: null,
    focusErrorsOnly: false,
    networkUrlFilter: '',
    networkTypeFilters: [],

    resetListFiltersForNewPlaybackSession: () => set({ networkUrlFilter: '', networkTypeFilters: [] }),

    setActiveTab: (activeTab) => set({ activeTab }),
    setSelectedId: (selectedId) => set({ selectedId }),

    setFocusErrorsOnly: (focusErrorsOnly) => set({ focusErrorsOnly }),
    setNetworkUrlFilter: (networkUrlFilter) => set({ networkUrlFilter }),
    toggleNetworkTypeFilter: (type) =>
      set((s) => {
        const prev = s.networkTypeFilters;
        const networkTypeFilters = prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type];
        return { networkTypeFilters };
      }),

    selectStep: (id) => set({ activeTab: 'steps', selectedId: id }),
    selectAction: (id) => set({ activeTab: 'actions', selectedId: id }),
    selectNetwork: (id) => set({ activeTab: 'network', selectedId: id }),
    selectEvent: (id) => set({ activeTab: 'events', selectedId: id }),
  };
}
